import { instance } from '@semantic-ui-react/event-stack';
export default instance;


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/lib/eventStack/index.js
// module id = 3320
// module chunks = 0